"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M14.334 2.376c.99 0 1.919.668 2.322 1.648l.065.175.321 1.066c.049.146.181.246.357.272l.091.006h3.615a2.898 2.898 0 0 1 2.89 2.725l.005.17V18.73a2.899 2.899 0 0 1-2.725 2.89l-.17.005H2.895A2.898 2.898 0 0 1 .005 18.9L0 18.73V8.438c0-1.538 1.207-2.8 2.725-2.889l.17-.005h3.614c.174 0 .33-.095.411-.244l.034-.079.325-.998c.34-1.027 1.236-1.761 2.214-1.84l.173-.006h4.668Zm0 1.04H9.666c-.552 0-1.099.41-1.349.993l-.052.138-.323.994a1.5 1.5 0 0 1-1.294 1.035l-.139.006H2.895c-.974 0-1.776.756-1.85 1.71l-.006.146V18.73c0 .975.756 1.776 1.711 1.85l.145.006h18.21c.975 0 1.776-.755 1.85-1.71l.006-.146V8.438c0-.973-.755-1.775-1.711-1.849l-.145-.006H17.49c-.623 0-1.155-.34-1.39-.876l-.048-.128-.322-1.064c-.197-.59-.717-1.031-1.268-1.092l-.128-.006ZM12 7.918a5.672 5.672 0 0 1 5.666 5.665A5.673 5.673 0 0 1 12 19.25a5.673 5.673 0 0 1-5.666-5.666A5.672 5.672 0 0 1 12 7.919Zm0 1.038a4.632 4.632 0 0 0-4.626 4.627A4.632 4.632 0 0 0 12 18.212a4.632 4.632 0 0 0 4.627-4.628A4.632 4.632 0 0 0 12 8.957Zm0 .648a.52.52 0 0 1 0 1.039 2.979 2.979 0 0 0-2.975 2.975.52.52 0 0 1-1.039 0A4.019 4.019 0 0 1 12 9.605Z",
    clipRule: "evenodd"
  })]
});